import debug from "debug";
const log = debug("cart-check");

function getRequestToken(
	requestTokenInputSelector = '#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]'
) {
	const input = document.querySelector(requestTokenInputSelector);

	if (!input || !input.value) {
		log("Error: Missing __RequestVerificationToken. Aborting");
		return false;
	}
	return input.value;
}

export default function requestCount(endpoint) {
	log(`Requesting count from ${endpoint}`);
	const requestToken = getRequestToken();

	if (!endpoint) {
		return Promise.reject("Error: Missing endpoint arg");
	}

	if (!requestToken) {
		return Promise.reject("Error: Missing __RequestVerificationToken. Aborting");
	}

	return fetch(endpoint, {
		method: "POST",
		body: JSON.stringify({
			__RequestVerificationToken: requestToken,
		}),
		headers: {
			"Content-Type": "application/json",
		},
	})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		})
		.then((count) => {
			log("Count", count);
			return count;
		})
		.catch((error) => {
			log("error", error);
		});
}



// WEBPACK FOOTER //
// ./client/src/core/components/cart-check/cart-check.js